
import Vue from 'vue';
import { State, Action, Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { mdiMagnify, mdiPlus, mdiSortVariant } from '@mdi/js';
import { mdiSortReverseVariant } from '@/helpers/iconsMdi';

import ReportSorter from '@/components/ReportSorter/AdminReportSorter.vue';
import ReportItem from '@/components/Administration/Report/ReportItem.vue';
import LoadMorePaginator from '@/components/Service/Base/LoadMorePaginator.vue';
import {SortModel, ReportItemModel, PageModel} from '@/models/reports';

const namespace = 'adminReports';
const toggles = [
  {key: 'sorter', icon: mdiSortVariant},
  {key: 'search', icon: mdiMagnify},
];

@Component({
  components: {
    ReportSorter,
    ReportItem,
    LoadMorePaginator,
  },
  data() {
    return {
      toggles,
      mdiPlus,
      mdiMagnify,
    };
  },
})
export default class ReportList extends Vue {
  @Getter('reports', { namespace } ) public reports!: ReportItemModel[];
  @Getter('sorting', { namespace } ) public sorting!: SortModel[];
  @Getter('paging', { namespace } ) public paging!: PageModel;
  @Getter('totalCount', { namespace } ) public totalCount!: number;

  @Action('load', { namespace }) public fetchData: any;
  @Action('changeContextFilter', { namespace }) public changeContextFilter: any;
  @Action('changeSorting', { namespace }) public changeSorting: any;
  @Action('changePaging', { namespace }) public changePaging: any;
  @Action('resetPagingSortingFilter', { namespace }) public resetPagingSortingFilter: any;

  public sorter: boolean = false;
  public search: boolean = false;
  public contextFilter: string = '';

  public mounted() {
    this.changeContextFilter('');
    this.resetPagingSortingFilter();
    this.fetchData();
  }

  public onContextFilter(val: string) {
    this.changeContextFilter(val);
  }

  public addNewReport(key: string) {
    this.$router.push({name: 'reportAdd'});
  }

  public editReport(report: any) {
    this.$router.push({name: 'reportEdit', params: {id: report.id }});
  }

  public toggle(key: string) {
    switch (key) {
      case 'sorter': this.sorter = !this.sorter; break;
      case 'search': this.search = !this.search; break;
    }
  }
  public getToggleClass(key: string) {
    let val = false;
    switch (key) {
      case 'sorter': val = this.sorter; break;
      case 'search': val = this.search ; break;
    }

    return `d-sm-none round-btn ${val ? 'round-btn--active' : ''}`;
  }

  public getSortIcon(id: string, isColor?: boolean) {
    const found = this.sorting.find((item) => item.sortBy === id);
    if (!isColor) {
      if (!found) { return mdiSortVariant; }
      return found.sortType === 'asc' ? mdiSortReverseVariant : mdiSortVariant;
    }
    if (isColor) {
      if (!found) { return '#caccdf'; }
      return 'green';
    }
  }

  public onSort(id: string) {
    const idx = this.sorting.findIndex((item) => item.sortBy === id);
    if (idx > -1) {
      const newSorting = [...this.sorting];
      if (this.sorting[idx].sortType === 'asc') {
        newSorting[idx] = { sortBy: id, sortType: 'desc' };
      } else {
        newSorting.splice(idx, 1);
      }
      this.changeSorting(newSorting);
      return;
    }
    return this.changeSorting([...this.sorting, { sortBy: id, sortType: 'asc' } ]);
  }
}
